import React from "react";
import "../../App.css";
import SideBar from "../layout/sidebar/Sidebar";
import DashboardNavBar from "../layout/DashboardNavBar";
import View from "./ViewProfile";

const ViewProfileCall = ({ match }) => {
  return (
    <div>
      <DashboardNavBar />
      <SideBar />
      <View id={match.params.id}/>
    </div>
  );
}

export default ViewProfileCall;